import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FaseService } from 'src/app/services/fase.service';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { Procesox } from 'src/app/models/procesox.model';
import { Contact } from 'src/app/models/contact.model';
import { Fases } from 'src/app/models/fases.model';
import { Panel } from 'src/app/models/panel.model';
import { UnificadoService } from 'src/app/services/unificado.service';

@Component({
  selector: 'app-proceso',
  templateUrl: './proceso.component.html',
  styleUrls: []
})
export class ProcesoComponent implements OnInit {

  MetodoFirma: any;
  listaFase: Fases = new Fases();
  FaseActual: string = '';
  Idproceso: string;
  ultimafase: number = 0;
  //Variables generales del proceso
  proceso: Procesox;
  Alunmno: Contact;
  Panel: Panel = new Panel();
  CursandoCuartoMedio = false;
  mayorEdad = false;

  // Variables para gatillar operaciones entre tabs
  _changeDocumentosCount: number = 0;
  _changeCarreraCount: number = 0;
  operacionContrato: string = '0'
  CargandoFases = true;
  template = `<div class="loader loader-7">
  <span></span>
  <span></span>
  <span></span>
</div>`;
  //https://www.npmjs.com/package/@tusharghoshbd/ngx-loader
  constructor(
    private route: ActivatedRoute,
    private proservice: ProcesoMatriculaService,
    private faseservice: FaseService,
    private unificado: UnificadoService) {
    this.faseservice.fase$.emit('1');

    this.listaFase.fase1 = true;
    this.listaFase.fase2 = false;
    this.listaFase.fase3 = false;
    this.listaFase.fase4 = false;
    this.listaFase.fase5 = false;
    this.listaFase.fase6 = false;
    this.listaFase.fase7 = false;

    this.listaFase.bloqueo1 = false;
    this.listaFase.bloqueo2 = true;
    this.listaFase.bloqueo3 = true;
    this.listaFase.bloqueo4 = true;
    this.listaFase.bloqueo5 = true;
    this.listaFase.bloqueo6 = true;
    this.listaFase.bloqueo7 = true;
    
    this.MetodoFirma = false;
    var MetodoFirma = this.unificado.getMetodoFirma().subscribe(
      (data: any) => { 
        this.MetodoFirma = data.ECertActivo
      },
      (error) => { 
        this.MetodoFirma = false
      }
    );

    this.route.params.subscribe(params => {
      if (params.id !== '' && params.id !== undefined) {
        this.Idproceso = `${params.id}`;
        this.faseservice.GetFaseActual(this.Idproceso).subscribe(
          (data: number) => {
            this.ultimafase = data;
          }
        )
      } else {
        this.CargandoFases = false;
      }
    });

  }
  ngOnInit(): void {
    // This is intentional
  }

  UpdateFase(fase: string, origen: string = '') {
    console.log('[PROCESO] UpdateFase', fase, origen)
    this.setFase(fase);
  }

  ocultarTodos() {
    const n = 7;
    for (let i = 0; i < n; i++) {
      this.listaFase[`fase${i.toString()}`] = false;
    }
  }

  setFase(fase: string) {
    if (this.ultimafase <= Number.parseInt(fase)) {
      this.ultimafase = Number.parseInt(fase);
      this.CargandoFases = false;
    }
    this.FaseActual = fase;

    switch (fase) {
      case '1'://1- Antecedentes Personales
        this.listaFase.fase1 = true;
        this.listaFase.activa1 = true;
        this.listaFase.activa2 = false;
        this.listaFase.activa3 = false;
        this.listaFase.activa4 = false;
        this.listaFase.activa5 = false;
        this.listaFase.activa6 = false;
        this.listaFase.activa7 = false;

        this.listaFase.bloqueo2 = true;
        this.listaFase.bloqueo3 = true;
        this.listaFase.bloqueo4 = true;
        this.listaFase.bloqueo5 = true;
        this.listaFase.bloqueo6 = true;
        this.listaFase.bloqueo7 = true;
        break;
      case '2'://2- Antecedentes Educacionales
        this.listaFase.fase1 = false;
        this.listaFase.fase2 = true;
        this.listaFase.fase3 = false;
        this.listaFase.fase4 = false;
        this.listaFase.fase5 = false;
        this.listaFase.fase6 = false;
        this.listaFase.fase7 = false;

        this.listaFase.activa1 = true;
        this.listaFase.activa2 = true;
        this.listaFase.activa3 = false;
        this.listaFase.activa4 = false;
        this.listaFase.activa5 = false;
        this.listaFase.activa6 = false;
        this.listaFase.activa7 = false;

        this.listaFase.bloqueo2 = false;
        this.listaFase.bloqueo3 = true;
        this.listaFase.bloqueo4 = true;
        this.listaFase.bloqueo5 = true;
        this.listaFase.bloqueo6 = true;
        this.listaFase.bloqueo7 = true;
        break;
      case '3'://3- Simulación
        this.listaFase.activa1 = true;
        this.listaFase.activa2 = true;
        this.listaFase.activa3 = true;
        this.listaFase.activa4 = false;
        this.listaFase.activa5 = false;
        this.listaFase.activa6 = false;
        this.listaFase.activa7 = false;

        this.listaFase.fase1 = false;
        this.listaFase.fase2 = false;
        this.listaFase.fase3 = true;
        this.listaFase.fase4 = false;
        this.listaFase.fase5 = false;
        this.listaFase.fase6 = false;
        this.listaFase.fase7 = false;


        this.listaFase.bloqueo1 = false;
        this.listaFase.bloqueo2 = false;
        this.listaFase.bloqueo3 = false;
        this.listaFase.bloqueo4 = true;
        this.listaFase.bloqueo5 = true;
        this.listaFase.bloqueo6 = true;
        this.listaFase.bloqueo7 = true;
        break;
      case '4'://4- Documentos Requeridos
        this.listaFase.activa1 = true;
        this.listaFase.activa2 = true;
        this.listaFase.activa3 = true;
        this.listaFase.activa4 = true;
        this.listaFase.activa5 = false;
        this.listaFase.activa6 = false;
        this.listaFase.activa7 = false;

        this.listaFase.fase1 = false;
        this.listaFase.fase2 = false;
        this.listaFase.fase3 = false;
        this.listaFase.fase4 = true;
        this.listaFase.fase5 = false;
        this.listaFase.fase6 = false;
        this.listaFase.fase7 = false;

        this.listaFase.bloqueo1 = false;
        this.listaFase.bloqueo2 = false;
        this.listaFase.bloqueo3 = false;
        this.listaFase.bloqueo4 = false;
        this.listaFase.bloqueo5 = true;
        this.listaFase.bloqueo6 = true;
        this.listaFase.bloqueo7 = true;
        break;
      case '5'://5- Contrato
        this.listaFase.activa1 = true;
        this.listaFase.activa2 = true;
        this.listaFase.activa3 = true;
        this.listaFase.activa4 = true;
        this.listaFase.activa5 = true;
        this.listaFase.activa6 = false;
        this.listaFase.activa7 = false;

        this.listaFase.fase1 = false;
        this.listaFase.fase2 = false;
        this.listaFase.fase3 = false;
        this.listaFase.fase4 = false;
        this.listaFase.fase5 = true;
        this.listaFase.fase6 = false;
        this.listaFase.fase7 = false;

        this.listaFase.bloqueo1 = false;
        this.listaFase.bloqueo2 = false;
        this.listaFase.bloqueo3 = false;
        this.listaFase.bloqueo4 = false;
        this.listaFase.bloqueo5 = false;
        this.listaFase.bloqueo6 = true;
        this.listaFase.bloqueo7 = true;
        break;
      case '6'://6- Pago de Matricula
        this.listaFase.activa1 = true;
        this.listaFase.activa2 = true;
        this.listaFase.activa3 = true;
        this.listaFase.activa4 = true;
        this.listaFase.activa5 = true;
        this.listaFase.activa6 = true;
        this.listaFase.activa7 = false;

        this.listaFase.fase1 = false;
        this.listaFase.fase2 = false;
        this.listaFase.fase3 = false;
        this.listaFase.fase4 = false;
        this.listaFase.fase5 = false;
        this.listaFase.fase6 = true;
        this.listaFase.fase7 = false;

        this.listaFase.bloqueo1 = false;
        this.listaFase.bloqueo2 = false;
        this.listaFase.bloqueo3 = false;
        this.listaFase.bloqueo4 = false;
        this.listaFase.bloqueo5 = false;
        this.listaFase.bloqueo6 = false;
        this.listaFase.bloqueo7 = true;
        break;
      case '7'://7- Matriculado
        this.listaFase.activa1 = true;
        this.listaFase.activa2 = true;
        this.listaFase.activa3 = true;
        this.listaFase.activa4 = true;
        this.listaFase.activa5 = true;
        this.listaFase.activa6 = true;
        this.listaFase.activa7 = true;

        this.listaFase.fase1 = false;
        this.listaFase.fase2 = false;
        this.listaFase.fase3 = false;
        this.listaFase.fase4 = false;
        this.listaFase.fase5 = false;
        this.listaFase.fase6 = false;
        this.listaFase.fase7 = true;

        this.listaFase.bloqueo1 = true;
        this.listaFase.bloqueo2 = true;
        this.listaFase.bloqueo3 = true;
        this.listaFase.bloqueo4 = true;
        this.listaFase.bloqueo5 = true;
        this.listaFase.bloqueo6 = true;
        this.listaFase.bloqueo7 = false;
        break;
      default:
        break;
    }
  }

  setCuartoMedio(cursando: boolean) {
    this.CursandoCuartoMedio = cursando;
  }

  setAlumno(alumno: Contact) {
    this.Alunmno = alumno;
  }

  setPanel(panel: any) {
    this.Panel = panel;
    console.log('[SET - PANEL CRM]');
    console.log(this.Panel);
  }

  SetMayorEdad(esMayor: boolean) {
    this.mayorEdad = esMayor;
  }

  GoToValidarDocumento() {
    console.log('[PROCESO] GoToValidarDocumento()')
    ++this._changeDocumentosCount;
    this.listaFase.bloqueo4 = false;
    this.listaFase.fase4 = true;
    this.listaFase.fase7 = false;
  }

  CambiarCarrera() {
    ++this._changeCarreraCount;

    this.listaFase.bloqueo3 = false;
    this.listaFase.activa3 = true;
    this.listaFase.fase3 = true;

    this.listaFase.activa4 = false;
    this.listaFase.fase4 = false;
  }

  GoToMatricula() {
    this.listaFase.bloqueo4 = true;
    this.listaFase.fase4 = false;
    this.listaFase.fase7 = true;
  }

  onGoToContrato(idProceso) {
    this.listaFase.activa5 = true;
    this.listaFase.fase5 = true;

    this.listaFase.fase1 = false;
  }
}
